import { FC, Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

import LoadingScreen from '../../components/Desktop/LoadingScreen';

const CompliancePage = lazy(() => import('./CompliancePage'));

/** Lazy route wrapper for `/compliance` and `/compliance/checklist`. */
export const ComplianceRoute: FC = () => (
  <Suspense fallback={<LoadingScreen />}>
    <Routes>
      <Route index element={<CompliancePage />} />
      <Route path="checklist" element={<CompliancePage wizardFocus />} />
      <Route path="checklist/:loginToken" element={<CompliancePage wizardFocus emailSignIn />} />
    </Routes>
  </Suspense>
);

export default ComplianceRoute;
